import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { LocationType, PopupDescription } from "@/store/types";
import { DataLayout, DeviceTypes } from "@/views/SharedViewStructures";
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

@Component
export default class Layout extends Vue {
  get isPortrait() {
    return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width;
  }

  get deviceType(): DeviceTypes {
    if (this.$vuetify.breakpoint.smAndDown) {
      return DeviceTypes.Mobile;
    } else {
      return DeviceTypes.Desktop;
    }
  }

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("config", patientNamespace)
  config!: any;

  get dataLayout(): DataLayout {
    if (this.current && this.current.census.minDataPatient) {
      return DataLayout.Min;
    } else {
      return DataLayout.Full;
    }
  }

  get showingPopupFullscreen() {
    const { width, height, mdAndDown } = this.$vuetify.breakpoint;
    const ratio = width / height;

    // Handle case where the body is only taking up a tiny portion of the screen
    // and trying to show the popup in there is not helpful. Is almost a sideways phone
    const shortAndWide = height < 900 && ratio > 1.5;

    return (
      this.showingPopup &&
      (this.popupDescription.location === this.fullscreen ||
        this.deviceType === DeviceTypes.Mobile ||
        this.dataLayout === DataLayout.Min ||
        mdAndDown ||
        shortAndWide)
    );
  }

  get showingPopup() {
    return this.$route.query.popupName;
  }

  @Getter("popupDescription", patientNamespace)
  popupDescription!: PopupDescription;

  get popupComponent() {
    return this.popupDescription.component;
  }

  fullscreen = LocationType.fullscreen;
  replace = LocationType.replace;
}
